import React from 'react'
import clsx from 'clsx'
import { selectFlagsEverLoaded, useFlagStore } from 'stores/flagStore'

// initialActiveCount is server-seeded (see PackageRoundsPlugin flags_props) so the button
// renders in its settled enabled/disabled state on first paint, before FlagLoader's fetch
// resolves — without it, `flags` defaults to [] which makes activeCount 0 and flashes the
// button disabled before flipping to its real state (mirrors FinalizationCTA's initialCounts).
export default function OpenFlagsCTA({ packageId, openingStates, showWhenEmpty = true, initialActiveCount = 0 }) {
  const flags = useFlagStore((state) => state.flags)
  const flagsEverLoaded = useFlagStore(selectFlagsEverLoaded)

  const liveActiveCount = flags.filter((f) => openingStates.includes(f.state)).length
  const activeCount = flagsEverLoaded ? liveActiveCount : initialActiveCount

  if (!showWhenEmpty && activeCount === 0) {
    return null
  }

  const disabled = activeCount === 0

  function handleClick() {
    if (disabled) return
    window.dispatchEvent(new CustomEvent('open-flags-sidebar', { detail: { packageId } }))
  }

  const buttonClasses = clsx('dome-btn dome-btn-base open-flags-cta', disabled && 'dome-btn-disabled')

  return (
    <button className={buttonClasses} onClick={handleClick} disabled={disabled}>
      <i className="fas fa-flag-swallowtail" />
      <span>open flags</span>
    </button>
  )
}
